import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import checkPasswordStrength from 'utils/checkPasswordStrength';
import { PasswordInputStyled, StyledStrength } from './styles/PasswordInputStyled';
import DefaultInput from '../DefaultInput';
import Message from '../InputMessage';

const PASSWORD_SHORT = 'short';
const PASSWORD_MEDIUM = 'medium';
const PASSWORD_STRONG = 'strong';

class PasswordInput extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      passwordStrength: null,
      inputType: 'password',
    };
    this.value = '';
    this.isError = false;
  }

  onChange = ({ value }) => {
    this.setState({
      passwordStrength: checkPasswordStrength(value),
    });
    this.value = value;
    this.isError = value.length < 6;
    this.props.onValueChange(value);
  };

  onFocusChange = ({ focused }) => {
    this.props.onFocusChange(focused);
  };

  onButtonClick = () => {
    const { inputType } = this.state;
    const { onButtonClick } = this.props;
    this.setState({
      inputType: inputType === 'password' ? 'text' : 'password',
    });
    onButtonClick();
  };

  getMessageStrengthProps = (strength) => {
    let result;
    const { goodPasswordPhrase, excellentPasswordPhrase, shortPasswordPhrase } = this.props;
    switch (strength) {
      case PASSWORD_SHORT:
        result = {
          color: 'red_bright',
          message: shortPasswordPhrase,
        };
        break;
      case PASSWORD_MEDIUM:
        result = {
          message: goodPasswordPhrase,
          color: 'yellow_dark',
        };

        break;
      case PASSWORD_STRONG:
        result = {
          message: excellentPasswordPhrase,
          color: 'green_light',
        };
        break;
      default:
        result = {
          color: 'red_bright',
          message: '',
        };
    }
    return result;
  };

  render() {
    const { isError, passwordStrength, inputType } = this.state;
    const {
      placeholder,
      showStrengthLine,
      buttonType,
      showText,
      hideText,
      getText,
      errorMessage,
    } = this.props;

    let messageProps = {};

    if (errorMessage) {
      messageProps.message = errorMessage;
    } else if (showStrengthLine) {
      messageProps = this.getMessageStrengthProps(passwordStrength);
    }

    let buttonCaption;
    if (buttonType === 'show') {
      buttonCaption = inputType === 'password' ? showText : hideText;
    } else {
      buttonCaption = getText;
    }

    return (
      <PasswordInputStyled>
        <DefaultInput
          {...this.props}
          isError={isError || Boolean(errorMessage)}
          placeholder={placeholder}
          onChange={this.onChange}
          type={inputType}
          buttonCaption={buttonCaption}
          onButtonClick={this.onButtonClick}
          onFocusChange={this.onFocusChange}
        />
        {showStrengthLine && <StyledStrength passwordStrength={passwordStrength} />}
        <Message {...messageProps} />
      </PasswordInputStyled>
    );
  }
}

PasswordInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  goodPasswordPhrase: PropTypes.string,
  excellentPasswordPhrase: PropTypes.string,
  shortPasswordPhrase: PropTypes.string,
  getText: PropTypes.string,
  showText: PropTypes.string,
  hideText: PropTypes.string,
  buttonType: PropTypes.oneOf(['get', 'show']),
  showStrengthLine: PropTypes.bool,
  errorMessage: PropTypes.string,
  onIsErrorChange: PropTypes.func,
  onValueChange: PropTypes.func,
  onButtonClick: PropTypes.func,
  onFocusChange: PropTypes.func,
};

PasswordInput.defaultProps = {
  goodPasswordPhrase: '',
  excellentPasswordPhrase: '',
  shortPasswordPhrase: '',
  getText: '',
  showText: '',
  hideText: '',
  buttonType: 'show',
  showStrengthLine: false,
  errorMessage: '',
  onIsErrorChange: Function.prototype,
  onValueChange: Function.prototype,
  onButtonClick: Function.prototype,
  onFocusChange: Function.prototype,
};

export default PasswordInput;
